import { $freeGet } from '@src/assets/js/request'

export async function getLicenseUrlRequest (): Promise<string> {
  const res = await $freeGet('/api/common/bizconfig/getMediaLicenseUrl')
  return res.data
}
